module.exports = __webpack_public_path__ + "static/GLE Inside-08d9ec36c6106bcbb348c6fa26b8877b.jpg";